module.exports = __webpack_public_path__ + "img/since-wizard.0c889093.png";